// Module
var code = `<div class="range-select-panel" {{^.visible}} style="display:none;" {{/}}>
    <terceraComboBox name="rangeComboBox"
                     tooltip="{{cbTooltip}}" />

    <terceraDateRangeLookup name="dateRangeLookup"
                            visible="{{dateRangeLookupVisibility}}"
                            on-componentRangeSelect="applyBtnClick" 
                            dateFrom="{{dateFrom}}"
                            dateTo="{{dateTo}}"/>

    <terceraButton name="refreshButton"
                   visible="{{refreshBtnVisibility}}"
                   tooltip="{{refreshBtnTT}}"
                   SVG="true"
                   terceraButtonStyle="js-button-refresh"
                   on-componentClick="refreshClick" />
</div>`;
// Exports
export default code;